import React, { Component } from "react";
import {
    Select,
    TextField
} from "@shopify/polaris";
import { } from "@shopify/polaris-icons";
import "./index.scss";

import Language from '../../i18n/Language';
const t = Language;

class FooterPageSelect extends Component {
    constructor(props) {
        super(props);
        this.state = {
            lessoptions: [
                { label: 5, value: 5 },
                { label: 10, value: 10 },
                { label: 30, value: 30 },
                { label: 50, value: 50 },
                { label: 70, value: 70 },
                { label: 100, value: 100 },
            ],
            options: [
                { label: 10, value: 10 },
                { label: 30, value: 30 },
                { label: 50, value: 50 },
                { label: 70, value: 70 },
                { label: 100, value: 100 },
            ],
            current_PageSize: props.current_PageSize,
            page: props.page,
            total: props.total,
            isLess: props.isLess, // true代表是默认5条
            isShort: props.isShort,
            tableLoading: props.tableLoading, // 表格loading
            custom_type: props.custom_type,
        };
    }

    shouldComponentUpdate(nextProps) {
        if (nextProps.page !== this.props.page) {
            this.setState({
                page: nextProps.page,
            })
        }
        if (nextProps.total !== this.props.total) {
            this.setState({
                total: nextProps.total,
            })
        }

        if (nextProps.isLess !== this.props.isLess) {
            this.setState({
                isLess: nextProps.isLess,
            })
        }

        if (nextProps.current_PageSize !== this.props.current_PageSize) {
            this.setState({
                current_PageSize: nextProps.current_PageSize,
            })
        }

        if (nextProps.isShort !== this.props.isShort) {
            this.setState({
                isShort: nextProps.isShort,
            })
        }

        if (nextProps.tableLoading !== this.props.tableLoading) {
            this.setState({
                tableLoading: nextProps.tableLoading,
            })
        }

        return true;
    }

    // 选择条数
    handleSelectChange = (e) => {
        this.props.changePageSize(e);
    }

    // 页码输入
    handlePageChange = (e) => {
        // 判断类型不是数字都设置为1
        let _val = e;
        if (isNaN(e) || !e) {
            _val = 1;
        }
        this.setState({
            page: _val,
        })
    }

    // 页码输入框失去焦点
    handlePageBlur = (e) => {
        // 判断页码是否符合
        let { page, total, current_PageSize } = this.state;
        let newPage = parseInt(e.target.value);
        let maxPage = Math.ceil(total / current_PageSize);
        let jumpPage = 1, isJump = false;
        if (maxPage === 1) {
            jumpPage = 1;
            isJump = false;
        } else if (newPage > maxPage) {
            jumpPage = maxPage;
            isJump = Boolean(page !== maxPage);
        } else if (newPage < 1) {
            jumpPage = 1;
            isJump = Boolean(page !== 1);
        } else {
            jumpPage = newPage;
            isJump = Boolean(page !== newPage);
        }

        this.setState({
            page: jumpPage,
        }, () => {
            if (isJump) {
                this.props.handlePageBlur(jumpPage);
            }
        })
    }

    render() {
        const {
            state: {
                lessoptions,
                options,
                current_PageSize,
                page,
                total,
                isLess,
                isShort,
                tableLoading,
                custom_type,
            },
            handleSelectChange
        } = this;

        const footer_text_front = <div className="page-footer-text">
            <div className="page-input" style={{ width: (`${page}`).length > 4 ? `${40 + (((`${page}`).length - 4) * 8)}px` : '40px' }}>
                <TextField
                    value={page}
                    onChange={this.handlePageChange}
                    onBlur={this.handlePageBlur}
                    type="number"
                    disabled={tableLoading}
                    autoComplete="off"
                />
            </div>
            {
                custom_type ? <span>{t("/ {{v1}} of {{v2}}", Math.ceil(total / current_PageSize), total)} {t(custom_type)}</span> :
                    <span>{t("/ {{v1}} of {{v2}} results", Math.ceil(total / current_PageSize), total)}</span>
            }
        </div>

        const footer_text_back = !Boolean(isShort) ? t("per page") : '';

        return (
            <div className="FooterPageSelect">
                {footer_text_front}
                <div className="f-line"></div>
                <div className="select-footerbox">
                    <span>{footer_text_back}</span>
                    <Select
                        options={isLess ? lessoptions : options}
                        onChange={handleSelectChange}
                        value={Number(current_PageSize)}
                        disabled={tableLoading}
                    />
                </div>
            </div>
        );
    }
}

export default FooterPageSelect;
